module.exports = __webpack_public_path__ + "static/media/trial1_4.06a3d142.png";